import * as React from 'react'
import {
  chakra,
  HTMLChakraProps,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useToast
} from '@chakra-ui/react'
import { useGeolocation } from 'hooks'
import { FooterHeading } from 'components/Footer/FooterHeading'
import { useAuthContext } from 'context/AuthProvider'
import { PrimaryButton } from 'components/Buttons'
import { useTranslation } from 'react-i18next'
import { SUCCESS_TOAST, ERROR_TOAST } from '../.../../../constants'

import { useCreateSubscriptionMutation } from 'generated/graphql'

export const SubscribeForm: React.FC<HTMLChakraProps<'form'>> = ({ ...props }) => {
  const { isAuthenticated, user } = useAuthContext()
  const [email, setEmail] = React.useState(() => (isAuthenticated ? user?.email : ''))
  const { t } = useTranslation()
  const toast = useToast()
  const { countryCode } = useGeolocation()

  const [subscribe] = useCreateSubscriptionMutation({
    onCompleted: () => {
      toast({
        ...SUCCESS_TOAST,
        title: 'Thank you for subscribing!'
      })
    },
    onError: (e: any) => {
      toast({
        ...ERROR_TOAST,
        title: e.message
      })
    }
  })
  return (
    <chakra.form
      {...props}
      onSubmit={(e: any) => {
        e.preventDefault()

        if (email && countryCode) {
          subscribe({
            variables: {
              input: {
                email,
                countryCode
              }
            }
          })
        }
      }}
    >
      <Stack spacing="4" mt={[16, 0, 0]} fontSize="sm">
        <FooterHeading>{t('footer.subscription_alert')}</FooterHeading>
        <Text>{t('footer.subscription_alert_description')}</Text>
        <Stack spacing="4" align="center" direction={{ base: 'column', md: 'row' }}>
          <Input
            bg={useColorModeValue('white', 'inherit')}
            placeholder={t('footer.subscribe_placeholder')}
            type="email"
            variant="filled"
            fontSize="sm"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            isDisabled={isAuthenticated}
            required
            focusBorderColor={useColorModeValue('blue.500', 'blue.300')}
            _placeholder={{
              opacity: 1,
              color: useColorModeValue('gray.500', 'whiteAlpha.700')
            }}
          />
          <PrimaryButton
            type="submit"
            colorScheme="orange"
            rounded={{ base: 'md', md: 'full' }}
            flexShrink={0}
            fontSize="xs"
            width={{ base: 'full', md: 'auto' }}
          >
            {t('footer.subscribe')}
          </PrimaryButton>
        </Stack>
      </Stack>
    </chakra.form>
  )
}
